import { useMemo } from 'react';

import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

import { filterRecommendedAssets, filterAvailableAssets } from '../utils/assetFilters';

interface UseAssetFilteringParams {
  recommendedAssets: RecommendedAsset[];
  availableAssets: AssetItem[];
  search: string;
}

interface UseAssetFilteringReturn {
  filteredRecommended: RecommendedAsset[];
  filteredOthers: AssetItem[];
}

/**
 * Custom hook for filtering assets based on search term
 */
const useAssetFiltering = ({ recommendedAssets, availableAssets, search }: UseAssetFilteringParams): UseAssetFilteringReturn => {
  const filteredRecommended = useMemo(() => filterRecommendedAssets(recommendedAssets, search), [recommendedAssets, search]);

  const filteredOthers = useMemo(
    () => filterAvailableAssets(availableAssets, filteredRecommended, search),
    [availableAssets, filteredRecommended, search],
  );

  return {
    filteredRecommended,
    filteredOthers,
  };
};

export default useAssetFiltering;
